import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const ChatBubble = withDefaultIconProps({ height: 30, width: 30 }, ({ color = '#1F2635', ...rest }) => (
  <Svg {...rest} viewBox="0 0 30 30">
    <Path
      d="M25.76 16.57V9.33C25.76 7.26 24.08 5.57 22.01 5.57H8.24C6.17 5.57 4.49 7.26 4.49 9.33V16.57C4.49 18.64 6.17 20.33 8.24 20.33H13.18L17.33 24.58C17.61 24.86 17.99 25.01 18.37 25.01C18.56 25.01 18.74 24.98 18.92 24.91C19.47 24.68 19.83 24.15 19.83 23.56V20.33H22.01C24.08 20.33 25.76 18.64 25.76 16.57ZM19.06 18.8C18.64 18.8 18.3 19.14 18.3 19.56V23.38L14.05 19.03C13.9 18.88 13.71 18.8 13.5 18.8H8.24C7.01 18.8 6.01 17.8 6.01 16.57V9.33C6.01 8.1 7.01 7.1 8.24 7.1H22.01C23.24 7.1 24.24 8.1 24.24 9.33V16.57C24.24 17.8 23.24 18.8 22.01 18.8H19.06Z"
      fill={color}
    />
  </Svg>
));
